export const getFileNameWithoutExtension = (fileName: string): string => {
  const split = fileName.split('.');

  return split.length > 1 ? split.slice(0, -1).join() : fileName;
};
